import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const tobaccoDryRoomProductionsApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyor-tobacco-dry-room-production/by-dates`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default tobaccoDryRoomProductionsApi;
